<div class="energy-label-history">
    <ev-grid-table [gridModel]="displayTemplate">
        <ev-th>
            @for (column of headers; track column.name) {
                @if (column?.isSortable) {
                    <ev-td
                        [area]="column.prop"
                        (click)="updateSort(column.prop)"
                        [isSelectable]="true"
                        [textAlignment]="column.textAlignment ?? 'left'"
                        [selected]="sortConfig().sortOption.prop == column.prop"
                    >
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                } @else {
                    <ev-td [area]="column.prop" [textAlignment]="column.textAlignment ?? 'left'">
                        {{ column.name.toUpperCase() }}
                    </ev-td>
                }
            }
        </ev-th>

        @if (tableData()) {
            @for (rowData of tableData(); track rowData.energyLabelID) {
                <ev-tr class="ev-row" [hasRowContent]="false">
                    <ev-td area="issuedDate" header="Dato" column title="Dato" [fontBold]="sortConfig().sortOption.prop == 'issuedDate'">
                        <div class="column-data">{{ rowData.issuedDate | date: "dd.MM.yyyy" | defaultconvert }}</div>
                    </ev-td>
                    <ev-td area="energyLabelLetter" header="Merke" column title="Merke" [fontBold]="sortConfig().sortOption.prop == 'energyLabelLetter'">
                        <div class="column-data">
                            <div class="energy-label-icon-wrapper">
                                <div
                                    class="energy-label-icon"
                                    [ngClass]="[
                                        rowData?.labelIsExpired ? 'expired-energy-label' : 'none-expired-energy-label',
                                        getEnergyLabelClass(
                                            rowData.energyLabelLetter,
                                            rowData.energyLabelVersion,
                                            rowData.energyLabelColorId
                                        ),
                                    ]"
                                ></div>
                            </div>
                        </div>
                    </ev-td>
                    <ev-td area="source" header="Kilde" column title="Kilde" [fontBold]="sortConfig().sortOption.prop == 'source'">
                        <div class="column-data">{{ rowData.source }}</div>
                    </ev-td>
                    <ev-td area="method" header="Metode" column title="Metode" [fontBold]="sortConfig().sortOption.prop == 'method'">
                        <div class="column-data">{{ rowData.method }}</div>
                    </ev-td>
                    <ev-td area="energyLabelID" header="Attestnr" column title="Attestnr">
                        <div class="column-data">
                            @if (rowData.certificateNumberURL) {
                                <a class="enova-link" href="{{ rowData.certificateNumberURL }}" target="_blank" rel="noopener noreferrer">
                                    <div class="value">{{ rowData.certificateNumber }}</div>
                                    <div class="external-link"></div>
                                </a>
                            } @else {
                                {{ getEnergyLabelEnovaNumber(rowData) | defaultconvert }}
                            }
                        </div>
                    </ev-td>
                    <ev-td area="buildingID" header="Bygning" column title="Bygning" [fontBold]="sortConfig().sortOption.prop == 'buildingID'">
                        <div class="column-data">{{ rowData.buildingID }}</div>
                    </ev-td>
                    <ev-td
                        area="functionalUnitNumber"
                        header="Bruksenhet"
                        column
                        title="Bruksenhet"
                        [fontBold]="sortConfig().sortOption.prop == 'functionalUnitNumber'"
                    >
                        <div class="column-data">{{ rowData.functionalUnitNumber }}</div>
                    </ev-td>
                </ev-tr>
            }
        }
    </ev-grid-table>

    @if (originalData()?.length > rowsToShow) {
        <div class="show-more-button">
            <button (click)="onShowMore()">Vis flere</button>
        </div>
    }
</div>
